// Small pure helpers for the announcement edit page, kept apart so they can be tested on their own.

// Uploaded files are stored as "<folder>/<UTC timestamp>-<number>-<original name>".
const STORED_NAME_PREFIX = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})\d*Z-\d+-/;

/** The original file name, without the folder and the upload stamp the storage adds. */
export function documentLabel(path?: string | null): string {
  const file = String(path || "").split("/").pop() || "";
  return file.replace(STORED_NAME_PREFIX, "");
}

/** When the file was uploaded (read from its stored name), as a readable IST date and time. */
export function documentUploadedAt(path?: string | null): string {
  const match = (String(path || "").split("/").pop() || "").match(STORED_NAME_PREFIX);
  if (!match) return "";
  const [, y, mo, d, h, mi, s] = match;
  const when = new Date(Date.UTC(+y, +mo - 1, +d, +h, +mi, +s));
  if (Number.isNaN(when.getTime())) return "";
  return when.toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "Asia/Kolkata",
  });
}

/** True when both paths are present and point at the same stored file. */
export function sameDocument(a?: string | null, b?: string | null): boolean {
  return !!a && !!b && a === b;
}

/** Picking a document fills the heading from the file name only when there is no heading yet. */
export function keepHeading(current: string | null | undefined, fileName: string): string {
  return String(current || "").trim() ? String(current) : fileName;
}

/** The message the server sent back, or a plain fallback, whatever shape the error has. */
export function apiMessage(error: any, fallback = "Something went wrong"): string {
  const candidates = [
    error?.data?.data?.message,
    error?.response?.data?.data?.message,
    error?.data?.message,
    error?.message,
  ];
  const found = candidates.find((value) => typeof value === "string" && value.trim());
  return found || fallback;
}

export type EditStep = "save" | "approve" | "publish";

/** Where the announcement is in Save, Approve, Publish. */
export function currentEditStep(
  hasPendingEdit: boolean,
  isApproved: boolean
): EditStep {
  if (!hasPendingEdit) return "save";
  return isApproved ? "publish" : "approve";
}
